module.exports = __webpack_public_path__ + "img/phone-import.1f66ff23.svg";